// Task 24835 - a missing or unparseable date used to come out as "56 years
// ago", because new Date(null) is the epoch and new Date("") is Invalid Date,
// and neither was checked. Every caller renders the result straight into the
// page, so an empty column quietly became a confident wrong answer. Returns
// an empty string instead, which reads as "we do not know" in all of them.
//
// Future dates are left alone deliberately: no current caller passes one, and
// silently turning "in 3 days" into something past-tense would be a worse lie
// than the one being fixed here.
export const HandleDateTimeAgo = (date) => {
  if (!date) return "";
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "";

  const seconds = Math.floor((new Date() - parsed) / 1000);

  let interval = seconds / 31536000;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " years ago";
    } else {
      return Math.floor(interval) + " year ago";
    }
  }

  interval = seconds / 2592000;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " months ago";
    } else {
      return Math.floor(interval) + " month ago";
    }
  }
  interval = seconds / 86400;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " days ago";
    } else {
      return Math.floor(interval) + " day ago";
    }
  }
  interval = seconds / 3600;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " hours ago";
    } else {
      return Math.floor(interval) + " hour ago";
    }
  }
  interval = seconds / 60;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " minutes ago";
    } else {
      return Math.floor(interval) + " minute ago";
    }
  }
  // Check if plural
  if (Math.floor(seconds) > 1) {
    return Math.floor(seconds) + " seconds ago";
  } else {
    return Math.floor(seconds) + " second ago";
  }
};
export const HandleDateTimeOnTheJob = (date) => {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);

  let interval = seconds / 31536000;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " years";
    } else {
      return Math.floor(interval) + " year";
    }
  }

  interval = seconds / 2592000;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " months";
    } else {
      return Math.floor(interval) + " month";
    }
  }
  interval = seconds / 86400;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " days";
    } else {
      return Math.floor(interval) + " day";
    }
  }
  interval = seconds / 3600;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " hours";
    } else {
      return Math.floor(interval) + " hour";
    }
  }
  interval = seconds / 60;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " minutes";
    } else {
      return Math.floor(interval) + " minute";
    }
  }
  // Check if plural
  if (Math.floor(seconds) > 1) {
    return Math.floor(seconds) + " seconds";
  } else {
    return Math.floor(seconds) + " second";
  }
};

export const handleDateTimeAgoFromNow = (date) => {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000);

  let interval = seconds / 31536000;

  // Check if its today then return "Today"

  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " years";
    } else {
      return Math.floor(interval) + " year";
    }
  }

  interval = seconds / 2592000;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " months";
    } else {
      return Math.floor(interval) + " month";
    }
  }
  interval = seconds / 86400;
  if (interval > 1) {
    // Check if plural
    if (Math.floor(interval) > 1) {
      return Math.floor(interval) + " days";
    } else {
      return Math.floor(interval) + " day";
    }
  }
  // interval = seconds / 3600;
  // if (interval > 1) {
  //   // Check if plural
  //   if (Math.floor(interval) > 1) {
  //     return Math.floor(interval) + " hours";
  //   } else {
  //     return Math.floor(interval) + " hour";
  //   }
  // }
  // interval = seconds / 60;
  // if (interval > 1) {
  //   // Check if plural
  //   if (Math.floor(interval) > 1) {
  //     return Math.floor(interval) + " minutes";
  //   } else {
  //     return Math.floor(interval) + " minute";
  //   }
  // }
  //
  // if (interval > 1) {
  //   // Check if plural
  //   if (Math.floor(seconds) > 1) {
  //     return Math.floor(seconds) + " seconds";
  //   } else {
  //     return Math.floor(seconds) + " second";
  //   }
  // }
  if (interval < 1) {
    return "Today";
  }
};
